<script>
  export let title;
  export let previewImage;
  export let url;
  export let description;
</script>

<div class="card mb-3">
  <div class="card-body">
    <div class="card-title">
      <h1>{title}</h1>
    </div>
    <a href={url}>{url}</a>
    <p class="card-text">{description}</p>
  </div>
  <img class="card-img-bottm img-fluid" src={previewImage} alt={description} />
</div>
